import { render } from "./Switch_Button_Billetterie_To_Sportif.vue?vue&type=template&id=4dd95ca0"
import script from "./Switch_Button_Billetterie_To_Sportif.vue?vue&type=script&lang=js"
export * from "./Switch_Button_Billetterie_To_Sportif.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Work\\Sportips\\Nouveaux modules\\nm_sportips-inscriptions\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__